import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "menu-nav" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-tie" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user-shield" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-from-bracket" }, null, -1)

import { ref, onMounted, watch, computed } from "vue";
import store from "@/store/index";
import { useRouter } from "vue-router";
import { useCookies } from "vue3-cookies";
import { USER, USER_LOGINED } from "@/const/cookie";
import commons from "@/utils/Common";

export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfor',
  setup(__props) {

const { cookies } = useCookies();
const router = useRouter();
const name = ref("");
const url = ref("");
const logOut = async () => {
  commons.logOut();
  router.push({ path: "/sign-in" });
};
const inform = async () => {
  router.push({ path: "/inform" });
};
const urlAvatar = computed(() => {
  return store.getters.isUrlAvatar;
});
const changePassword = async () => {
  router.push({ path: "/change-password" });
};
onMounted(() => {
  let user = cookies.get(USER);
  if (user != null && user != undefined) {
    name.value = user.name;
    url.value = user.urlAvatar;
  }
});

watch(urlAvatar, (newValue, oldValue) => {
  url.value = JSON.parse(JSON.stringify(newValue));
});

return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dropdown, null, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_dropdown_item, { onClick: inform }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createTextVNode(" Thông tin người sử dụng ")
              ]),
              _: 1
            }),
            _createVNode(_component_el_dropdown_item, { onClick: changePassword }, {
              default: _withCtx(() => [
                _hoisted_3,
                _createTextVNode(" Thay đổi mật khẩu ")
              ]),
              _: 1
            }),
            _createVNode(_component_el_dropdown_item, { onClick: logOut }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" Đăng xuất ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", {
          class: "el-dropdown-link",
          onClick: inform
        }, [
          _createVNode(_component_el_link, { class: "user-name" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(name.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_avatar, {
            size: "small",
            src: url.value
          }, null, 8, ["src"])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})